export const treeTheme = {
  colorScheme: {
    light: {
      root: {
        padding: '0',
        gap: '0'
      },
      node: {
        gap: '0',
        background: 'transparent',
        hoverBackground: 'transparent'
      }
    },
    dark: {
      root: {
        padding: '0',
        gap: '0'
      },
      node: {
        gap: '0',
        background: 'transparent',
        hoverBackground: 'transparent'
      }
    }
  }
};
